import {Mapper} from '@s-ui/domain'
import {slugify} from '@s-ui/js/lib/string'

export class HttpSubscriptionSearchResultsResponseToSubscriptionAdsListValueObjectMapper extends Mapper {
  constructor({subscriptionAdEntityFactory, subscriptionAdsListValueObjectFactory}) {
    super()
    this._subscriptionAdEntityFactory = subscriptionAdEntityFactory
    this._subscriptionAdsListValueObjectFactory = subscriptionAdsListValueObjectFactory
  }

  _getItems = items => {
    return items.map(item => {
      const {
        commitmentOptions = [],
        fuelTypeId,
        minimumFee: minimumMonthlyFee,
        powerHp,
        providerName,
        resources,
        transmissionTypeId,
        year
      } = item

      const commitmentMonthlyOptions = commitmentOptions.filter(option => option !== 0)

      const [{url: imgUrl} = {}] = resources

      return this._subscriptionAdEntityFactory({
        ...item,
        commitmentMonthlyOptions,
        specificFuelTypeId: fuelTypeId,
        hasNoCommitmentOption: commitmentOptions.includes(0),
        imgUrl,
        minimumMonthlyFee,
        partnerName: slugify(providerName),
        powerHp,
        transmissionTypeId,
        year
      })
    })
  }

  map(searchResultsResponse) {
    const {
      items,
      meta: {totalPages, totalResults}
    } = searchResultsResponse

    return this._subscriptionAdsListValueObjectFactory({
      items: this._getItems(items),
      totalPages,
      totalResults
    })
  }
}
